module.exports = __webpack_public_path__ + "static/14-b0d93f848c3e25539f0612fc43b96eda.png";